
import { defineComponent, computed } from 'vue';

export default defineComponent({
  props: {
    color: {
      type: String,
      required: true,
    },
    image: {
      type: String,
      required: true,
    },
  },
  setup(props) {
    const bannerImage = computed(() => {
      return { backgroundImage: `url(${props.image})` };
    });

    const bannerSkin = computed(() => {
      return { height: '50vh', backgroundColor: props.color };
    });
    return {
      bannerImage,
      bannerSkin,
    };
  },
});
